import React from 'react';
import { useStyleConfig, vui } from '../core';
import Icon from '../icon';
import { cs } from '../utils';
import { inputColors } from './consts';
import { useInputContext } from './context';
/** Displays an icon within the Input. */
export const InputIcon = vui((props, ref) => {
    const { className, ...rest } = props;
    const inputProps = useInputContext();
    const mergedProps = { ...inputProps, ...props };
    const styles = useStyleConfig('Input', mergedProps);
    const color = !mergedProps.disabled ? inputColors.icons : inputColors.placeholder;
    return React.createElement(Icon, { className: cs('vui-inputIcon', className), color: color, ref: ref, ...styles.icon, ...rest });
});
export default InputIcon;
